//視聴機能
Howler.autoUnlock = false;
class AudioPlayer extends HTMLElement {
  constructor() {
    super();
    //trackInfomation
    this.info = {},this.sound,this.requestID,this.duration;
    //events
    this.querySelector('#playerContentClose').addEventListener('click', this.close.bind(this));
    this.querySelector('#playPauseButton').addEventListener('click', this.togglePlay.bind(this));
    this.querySelector('#playerPrevButton').addEventListener('click', this.prevNext.bind(this,-1));
    this.querySelector('#playerNextButton').addEventListener('click', this.prevNext.bind(this,1));
    this.querySelector('#playerLine').addEventListener('mouseup', this.seek.bind(this));
  }
  connectedCallback() {
    if (!this.rendered) {
      this.rendered = true;
    }
  }
  static get observedAttributes() {
    return ['index',"image","link","names","files"];
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if(name === "index" && newValue ){
      this.info.index = Number(newValue);
      this.info.currentPercent = 0;
      this.init();
    }else if(newValue && newValue !== oldValue){
      let value = "";
      if(name === "names" || name === "files"){
        value =  JSON.parse(newValue);
      }else{
        value = newValue;
      }
      this.info[name] = value;
    }
  }
  init(){
    this.soundInit();
    this.setTrack(true,this.info);
    this.buttunDisabled();
    this.bar();
    this.open();
  }
  soundInit(){
    const self = this;
    if(this.sound){
      this.sound.unload();
    }
    this.sound = new Howl({
      src: this.info.files[this.info.index],
      html5: true,
    });
    this.sound.on("load",()=>{
      self.duration = self.sound.duration();
    })
    this.sound.on("end",()=>{
      if(self.info.index !== self.info.names.length - 1){
        self.prevNext(1);
      }else{
        document.querySelector('#playPauseButton').classList.remove("on");
      }
    })
    this.play();
  }
  open(){
    this.classList.add('active');
  }
  close() {
    this.classList.remove('active');
    this.sound.unload();
  }
  togglePlay() {
    if(this.sound.playing()){
      this.pause();
    }else{
      this.play();
    }
  }
  play(){
    this.sound.play();
    document.querySelector('#playPauseButton').classList.add("on");
  }
  pause(){
    this.sound.pause();
    document.querySelector('#playPauseButton').classList.remove("on");
  }
  prevNext(direction){
    this.info.index += direction;
    this.sound.unload();
    this.soundInit();
    this.buttunDisabled();
    this.setTrack(false,this.info);
  }
  buttunDisabled(){
    const playerNextButton = document.querySelector('#playerNextButton')
    const playerPrevButton = document.querySelector('#playerPrevButton')
    if( this.info.index === this.info.names.length - 1){
      playerNextButton.disabled = true;
    }else{
      playerNextButton.disabled = false;
    }
    if(this.info.index === 0){
      playerPrevButton.disabled = true;
    }else{
      playerPrevButton.disabled = false;
    }
  }
  setTrack(init,info){
    const playerTitleLink = document.querySelector('#playerTitleLink');
    const playerImageLink = document.querySelector('#playerImageLink');
    if(init){
      const playerImage = document.querySelector('#playerImage');
      playerImage.src = info.image;
      playerImageLink.href = info.link;
      const playerAllTrack = document.querySelector('#playerAllTrack');
      playerAllTrack.innerHTML = info.names.length;
      playerTitleLink.href = info.link;
    }
    playerTitleLink.innerHTML = info.names[this.info.index];
    const playerCurrentTrack = document.querySelector('#playerCurrentTrack');
    playerCurrentTrack.innerHTML = this.info.index + 1;
    const playerCursor = document.querySelector('#playerCursor');
    this.info.currentPercent = 0;
    playerCursor.style.width = this.info.currentPercent + "%";
  }
  seek(e){
    const playerLine = e.currentTarget;
    const clickX = e.pageX ;
    // 要素の位置を取得
    const clientRect = playerLine.getBoundingClientRect() ;
    const positionX = clientRect.left + window.pageXOffset ;
	// 要素内におけるクリック位置を計算
    const x = clickX - positionX ;
    const playerCursor = document.querySelector('#playerCursor');
    this.info.currentPercent = (x/e.currentTarget.clientWidth);
    this.sound.seek(this.info.currentPercent * this.duration)
    playerCursor.style.width = (this.info.currentPercent* 100) + "%";
  }
  bar(){
    const self = this;
    function getTime(){
      const persent = self.sound.seek() ? (self.sound.seek() / self.duration)*100 : 0;
      playerCursor.style.width = persent + "%";
      self.requestID = requestAnimationFrame(getTime);
    }
    getTime()
  }
}
customElements.define('audio-player', AudioPlayer);